module.exports = __webpack_public_path__ + "static/media/salesforce_logo.311086ae.svg";